<script setup lang="ts">
import { Resources } from "../../interface/ResourcesInterface";

const emit = defineEmits(["close"]);

const props = defineProps<{
  resource: Resources;
}>();
</script>

<template>
  <div class="modal-backdrop" @click="emit('close')">
    <div class="modal fade show">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title fw-bold">{{ props.resource.name }}</p>
            <button
              type="button"
              class="btn-close"
              @click="emit('close')"
            ></button>
          </div>
          <div class="modal-body">
            <iframe
              width="560"
              height="315"
              :src="`https://www.youtube.com/embed/${props.resource.link}`"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.modal-dialog {
  max-width: 850px;

  iframe {
    width: 100%;
    aspect-ratio: 16 / 9;
    height: 100%;
    border: none;
  }
}
</style>
